import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
}

export const AtlassianIcon: React.FC<IconProps> = ({ size = 32, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Atlassian"
  >
    <defs>
      <linearGradient
        id="atlassian-grad"
        x1="7.5"
        y1="20.3"
        x2="16.6"
        y2="6.8"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0%" stopColor="#0052CC" />
        <stop offset="100%" stopColor="#2684FF" />
      </linearGradient>
    </defs>
    <path
      d="M11.12 15.27c-.33-.4-.88-.38-1.14.07L5.06 24.5a.72.72 0 0 0 .63 1.06h7.12a.72.72 0 0 0 .65-.41c1.37-2.9.78-7.2-2.34-9.88Z"
      fill="url(#atlassian-grad)"
    />
    <path
      d="M15.57 3.14a14.56 14.56 0 0 0-.57 15.37l3.47 6.54a.72.72 0 0 0 .64.4h7.12a.72.72 0 0 0 .63-1.06L16.73 3.21a.72.72 0 0 0-1.16-.07Z"
      fill="#2684FF"
    />
  </svg>
);
